import React, { PureComponent, Fragment } from "react";
import Form from "js/pages/Admin/Proveedor/Sucursal/Edit/MyForm.js";
import AppQraphQL from "js/graphql/resolvers/proveedor.resolver";
import { get } from "lodash";

class Edit extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: { estado: "ACTIVO" },
      disabled: null,
      idProveedor:
        parseInt(this.props.match.params.idProveedor) ||
        this.props.match.params.idProveedor,
      proveedor: "",
      idSucursal:
        parseInt(this.props.match.params.idSucursal) ||
        this.props.match.params.idSucursal,
      errors: null
    };
  }

  async componentDidMount() {
    const { client } = this.props;
    const {
      match: {
        params: { idSucursal, edit }
      }
    } = this.props;

    await client
      .query({
        query: AppQraphQL.queries.getProveedorSimpleById,
        fetchPolicy: "cache-first",
        variables: {
          idProveedor:
            parseInt(this.state.idProveedor) || this.state.idProveedor
        }
      })
      .then(res => {
        const data = get(res, ["data", "getProveedores", "itemsPagina"], null);
        if (data)
          this.setState({
            proveedor: data[0].nombreFantasia
          });
      });

    if (idSucursal !== "new") {
      await client
        .query({
          query: AppQraphQL.queries.getSucursalById,
          fetchPolicy: "network-only",
          variables: {
            idSucursal
          }
        })
        .then(res =>
          this.setState({
            initialValues: {
              ...res.data.getSucursales.itemsPagina[0],
              idPais:
                (res.data.getSucursales.itemsPagina[0].pais &&
                  parseInt(
                    res.data.getSucursales.itemsPagina[0].pais.idPais
                  )) ||
                (res.data.getSucursales.itemsPagina[0].pais &&
                  res.data.getSucursales.itemsPagina[0].pais.idPais),
              idZona:
                (res.data.getSucursales.itemsPagina[0].zona &&
                  parseInt(
                    res.data.getSucursales.itemsPagina[0].zona.idZona
                  )) ||
                (res.data.getSucursales.itemsPagina[0].zona &&
                  res.data.getSucursales.itemsPagina[0].zona.idZona),
              idLocalidad:
                (res.data.getSucursales.itemsPagina[0].localidad &&
                  parseInt(
                    res.data.getSucursales.itemsPagina[0].localidad.idLocalidad
                  )) ||
                (res.data.getSucursales.itemsPagina[0].localidad &&
                  res.data.getSucursales.itemsPagina[0].localidad.idLocalidad)
            },
            disabled: !(edit === "edit")
          })
        );
    }
  }

  async submit(values) {
    const {
      client,
      history,
      match: {
        params: { idProveedor, idSucursal }
      }
    } = this.props;

    await client
      .mutate({
        mutation:
          idSucursal === "new"
            ? AppQraphQL.mutations.createSucursal
            : AppQraphQL.mutations.updateSucursal,
        variables: {
          sucursal:
            idSucursal === "new"
              ? {
                  idProveedor: parseInt(idProveedor, 10),
                  nombre: values.nombre,
                  telefono: values.telefono,
                  direccion: values.direccion,
                  idPais: get(values, "idPais", null),
                  idZona: get(values, "idZona", null),
                  idLocalidad: get(values, "idLocalidad", null),
                  notas: values.notas,
                  orden: values.orden
                }
              : {
                  idProveedor: parseInt(idProveedor, 10),
                  idSucursal: parseInt(idSucursal, 10),
                  estado: values.estado,
                  nombre: values.nombre,
                  telefono: values.telefono,
                  direccion: values.direccion,
                  idPais: get(values, "idPais", null),
                  idZona: get(values, "idZona", null),
                  idLocalidad: get(values, "idLocalidad", null),
                  notas: values.notas,
                  orden: values.orden
                }
        }
      })
      .then(res => {
        const message = "Sucursal grabada correctamente";
        this.props.openNotification(message);
        history.push(
          `/admin/proveedor/${parseInt(idProveedor) || idProveedor}/sucursal`
        );
      })
      .catch(e => {
        this.setState({ errors: e });
        return false;
      });
  }
  render() {
    return (
      <Fragment>
        <Form
          id={this.state.idProveedor}
          proveedor={this.state.proveedor}
          idSucursal={this.state.idSucursal}
          errors={this.state.errors}
          disabled={this.state.disabled}
          initialValues={this.state.initialValues}
          onSubmit={this.submit.bind(this)}
        />
      </Fragment>
    );
  }
}

export default Edit;
